import React, { MouseEventHandler, ReactNode } from 'react';
import { ControllerFieldState, ControllerRenderProps } from 'react-hook-form/dist/types/controller';
import {
  FormControlLabel,
  FormGroup,
  FormHelperText, Switch,
} from '@material-ui/core';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import { getFinalErrorMessage } from 'lib/form/FormUtils';
import { UseFormStateReturn } from 'react-hook-form/dist/types';

type Props = {
  control: {
    field: ControllerRenderProps<any, any>,
    fieldState: ControllerFieldState,
    formState: UseFormStateReturn<any>,
  },
  label: ReactNode
  error: FieldErrors,
  apiErrors?: { [key: string]: string[] }
  onClick?: MouseEventHandler
};

export default function SwitchWrapper(
  {
    control,
    label,
    error,
    apiErrors,
    onClick,
  }: Props,
) {
  const { field } = control;
  const errorMessage = getFinalErrorMessage(field.name, error, apiErrors);

  return (
    <div className="material-textfield-wrapper">
      <FormGroup>
        <FormControlLabel
          control={(
            <Switch
              {...field}
              value={!!field.value}
              checked={!!field.value}
              onClick={onClick}
            />
          )}
          label={label}
        />
        {!!errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
      </FormGroup>
    </div>
  );
}
